import { IncidentFilters } from '../../services/quality'

export function hasActiveTicketFilters(f: IncidentFilters): boolean {
  return Object.entries(f).some(([, v]) => {
    if (Array.isArray(v)) return v.length > 0
    return v !== undefined && v !== ''
  })
}

export function getLast30DaysDates() {
  const hoje = new Date()
  const fim = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())
  const inicio = new Date(fim)
  inicio.setDate(inicio.getDate() - 30)

  const formatDate = (date: Date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  return { inicio: formatDate(inicio), fim: formatDate(fim) }
}

export function buildDefaultDashFilters(): IncidentFilters {
  const { inicio, fim } = getLast30DaysDates()
  return { dateFrom: inicio, dateTo: fim }
}
